import Link from '@components/common/Link';
import styled from 'styled-components';
import { theme } from 'tailwind.config';

export const StyledLink = styled(Link)`
  margin-bottom: 2rem;
  color: ;
  height: auto;
  display: flex;
  align-items: center;
  font-weight: 200;
  color: ${theme.colors.white};
  :hover {
    color: ${theme.colors.white};
  }
  svg {
    fill: ${theme.colors.white};
  }
`;

export const SocialMediaIcon = styled.div`
  width: 2.4rem;
  display: flex;
  margin-right: 1rem;
  align-self: center;
  img,
  svg {
    width: 100%;
  }
`;
